import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectCampaignSetupDetails = (state: RootState) => state.campaignSetup;
const selectJobTitle = (state: RootState) => state.campaignSetup.jobTitle;
const selectJobLocations = (state: RootState) =>
  state.campaignSetup.jobLocations;
const selectJobMode = (state: RootState) => state.campaignSetup.jobMode;
const selectExperienceRange = (state: RootState) =>
  state.campaignSetup.experienceRange;
const selectSalaryRange = (state: RootState) => state.campaignSetup.salaryRange;
const selectIsSalaryRangeFilledInSetup = (state: RootState) =>
  state.campaignSetup.isSalaryRangeFilledInSetup;
const selectNoticePeriod = (state: RootState) =>
  state.campaignSetup.noticePeriod;
const selectCampaignName = (state: RootState) =>
  state.campaignSetup.campaignName;
const selectSelectedFolder = (state: RootState) =>
  state.campaignSetup.selectedFolder;
const selectNumberOfSelectedCandidates = (state: RootState) =>
  state.campaignSetup.numberOfSelectedCandidates;
const selectIsSendToAlreadyContacted = (state: RootState) =>
  state.campaignSetup.isSendToAlreadyContacted;

const selectMailStripData = (state: RootState) =>
  state.campaign.mailStripData;

const selectBannerData = (state: RootState) =>
  state.campaign.bannerData;
const selectInventory = (state: RootState) =>
  state.campaign.inventoryUsage;

const jobTitleSelector = createSelector(selectJobTitle, (jobTitle) => {
  return { jobTitle };
});

const mailStripSelector = createSelector(selectMailStripData, (mailStripData)=> {
  return {mailStripData}
});

const bannerDataSelector = createSelector(selectBannerData, (bannerData)=> {
  return {bannerData}
})
const inventoryUsageSelector = createSelector(selectInventory, (inventoryUsage)=> {
  return {inventoryUsage}
})

const selectedJobLocationsSelector = createSelector(
  selectJobLocations,
  (selectedJobLocations) => {
    return { selectedJobLocations };
  }
);

const jobModeSelector = createSelector(selectJobMode, (jobMode) => {
  return { jobMode };
});

const experienceRangeSelector = createSelector(
  selectExperienceRange,
  (experienceRange) => {
    return { experienceRange };
  }
);

const salaryRangeSelector = createSelector(selectSalaryRange, (salaryRange) => {
  return { salaryRange };
});

const isSalaryRangeFilledInSetupSelector = createSelector(
  selectIsSalaryRangeFilledInSetup,
  (isSalaryRangeFilledInSetup) => {
    return { isSalaryRangeFilledInSetup };
  }
);

const noticePeriodSelector = createSelector(
  selectNoticePeriod,
  (noticePeriod) => {
    return { noticePeriod };
  }
);

const campaignNameSelector = createSelector(
  selectCampaignName,
  (campaignName) => {
    return { campaignName };
  }
);

const selectedFolderSelector = createSelector(
  selectSelectedFolder,
  (selectedFolder) => {
    return { selectedFolder };
  }
);

const numberOfSelectedCandidatesSelector = createSelector(
  selectNumberOfSelectedCandidates,
  (numberOfSelectedCandidates) => {
    return { numberOfSelectedCandidates };
  }
);

const isSendToAlreadyContactedSelector = createSelector(
  selectIsSendToAlreadyContacted,
  (isSendToAlreadyContacted) => {
    return { isSendToAlreadyContacted };
  }
);

const campaignSetupDetailsSelector = createSelector(
  selectCampaignSetupDetails,
  ({
    campaignName,
    experienceRange,
    isSendToAlreadyContacted,
    selectedFolder,
    salaryRange,
    jobLocations,
    numberOfSelectedCandidates,
    jobMode,
    jobTitle,
    noticePeriod,
    isSalaryRangeFilledInSetup
  }) => {
    const setUpDetails = {
      campaignName,
      experienceRange,
      isSendToAlreadyContacted,
      selectedFolder,
      salaryRange,
      jobLocations,
      numberOfSelectedCandidates,
      jobMode,
      jobTitle,
      noticePeriod,
      isSalaryRangeFilledInSetup
    };
    return { setUpDetails };
  }
);

export {
  jobTitleSelector,
  selectedJobLocationsSelector,
  jobModeSelector,
  experienceRangeSelector,
  salaryRangeSelector,
  campaignNameSelector,
  selectedFolderSelector,
  numberOfSelectedCandidatesSelector,
  isSendToAlreadyContactedSelector,
  campaignSetupDetailsSelector,
  noticePeriodSelector,
  isSalaryRangeFilledInSetupSelector,
  mailStripSelector,
  bannerDataSelector,
  inventoryUsageSelector
};
